import { Flex, VStack, Text, HStack, Image, Button, Stack, useMediaQuery, Heading, Box } from '@chakra-ui/react';
import checkmark from 'Assets/svg/Checkmark.svg';
import React from 'react';
import phoneLoop from 'Assets/Images/phone-loop.png';
import phoneLoopMobile from 'Assets/Images/PhoneLoopMobile.png';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import useLocalizedNavigate from 'Utils/useLocalizedNavigate';
import { AppRoutes } from 'Routes/AppRoutes';
import { IChildren, ILoopBusinessLocalizationDocument } from 'Types/Interface/Sanity';


interface ICustomerProps{
	shouldIgnoreParentPadding: boolean;
	loopBusinessLocalization: ILoopBusinessLocalizationDocument | null;
}

export const Customer = ({shouldIgnoreParentPadding, loopBusinessLocalization}:ICustomerProps) => {
	const [isLargerThan768] = useMediaQuery('(min-width: 984px)');
	const navigate = useLocalizedNavigate();
	
	return(
		<Flex  
			direction={['column-reverse', 'column-reverse', 'column-reverse', 'row']} 
			bg={['#FFFCFC','#FFFCFC']} 
			w={'100%'} 
			justifyContent={['center', 'space-between', 'space-between']}
			py={['50px','100px']}
			{...(shouldIgnoreParentPadding && { px:{ base: '30px', xl: '80px', '2xl': '192px' }})}
		>
			{ isLargerThan768 ? <Flex maxWidth={'50%'} alignItems={'flex-end'} bg={['','#F5F5F5']} justifyContent={'center'}  w={'550px'} h={'650px'}>
				<Image w={'610px'}  objectFit={'contain'} h={'548px'} src={phoneLoop} />
			</Flex> :
				<Flex alignItems={'flex-end'} justifyContent={'center'} mt={['30px','50px']}>
					<Image w={['388px', '100%', '100%']}  objectFit={'contain'}  src={phoneLoopMobile} />
				</Flex>
			}
			<VStack w={['100%', '100%', '100%', '45%']} justifyContent={'center'} spacing={['30px','40px']}  align={['flex-start','flex-start']}>
				<Stack spacing={[null,-2]} >
					<Heading textTransform={'uppercase'} fontSize={['30px','40px']} fontWeight={'bold'}>{loopBusinessLocalization?.customerRelationship}</Heading>
					{/* <Heading fontSize={['20px','40px']} fontWeight={'extrabold'}>
						Relationships With Loop
					</Heading> */}
				</Stack>
				
				<VStack gap={'30px'} justifyContent={'center'} align={'flex-start'}>
					{
						loopBusinessLocalization?.customerRelationshipItem.map((benefit) => {
							return(
								<HStack spacing={'4px'} w={['100%','auto']} alignItems={'baseline'} key={benefit._key}>
									<Image pos={'relative'} top={'5px'} boxSize={'20px'} src={checkmark} />
									<VStack alignItems={'flex-start'}>
										{benefit.children.map((child: IChildren) => {
											const isBold = child.marks.includes('strong');

											if (isBold) {
												return (
													<Heading
														key={child._key}
														as="strong"
														display={{ base: 'block', md: 'inline' }}
														fontSize={['16px', '18px']}
													>
														{child.text}
													</Heading>
												);
											}

											return (
												<Box
													key={child._key}
													as="span"
													display={{ base: 'block', md: 'inline' }}
													color={'blackText.200'} fontSize={['16px', '18px']}
												>
													{child.text}
												</Box>
											);
										})}
									</VStack>
								</HStack>
							);
						})
					}
				</VStack>
				<Button
					w={['auto','220px']}
					h={['40px','60px']}
					variant={'primary'}
					onClick={() => navigate(AppRoutes.processOverview)}
				>
					Learn How it Works
					<ArrowForwardIcon ml={2} boxSize={5} />
				</Button>
			</VStack>
		</Flex>
	);
};